// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"15e82798","422":"331ed810","555":"7eaa2387","682":"aca0a6ff"}[chunkId] + ".chunk.css";
};